import { render, staticRenderFns } from "./TreatmentTab.vue?vue&type=template&id=3c8a6f0c&"
import script from "./TreatmentTab.vue?vue&type=script&lang=js&"
export * from "./TreatmentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports